import { createAction } from 'redux-actions';

export const FETCHED_CATEGORIES = 'FETCHED_CATEGORIES';

export const fetchedCategories = createAction(FETCHED_CATEGORIES, data => data);
